import { render, staticRenderFns } from "./Ended.vue?vue&type=template&id=e15b97bc&scoped=true&"
import script from "./Ended.vue?vue&type=script&lang=js&"
export * from "./Ended.vue?vue&type=script&lang=js&"
import style0 from "./Ended.vue?vue&type=style&index=0&id=e15b97bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15b97bc",
  null
  
)

export default component.exports